import React from "react";
// import GoogleMapReact from 'google-map-react';
import Api from "Helpers/ApiHandler";
import { connect } from "react-redux";
import { DashboardWrapper } from "./Dashboard.style";
// import MapMarkerDetail from "./MapMarkerDetail/MapMarkerDetail";
import { showToast } from "Redux/General/Actions";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
// import { CircularProgress } from "@material-ui/core";
import GMap from "Components/Map/GMap";
let { differenceBy } = require("lodash");

// const defaultMarkers = [
//     {
//         id: "9ef04337-5e55-4979-8041-86d53184a375",
//         pin_type: "E_BIN",
//         address: "OpenXcell, Bodakdev, Ahmedabad, Gujarat, India",
//         latitude: 23.0340847,
//         longitude: 72.5106668,
//         pincode: 124578,
//         bin_identifier: "123456",
//         distance: 6.036192848767235
//     }
// ];
class Dashboard extends React.Component {
    totalRecordsPerPage = 3;
    differMarkers = []
    offsetType = 0
    constructor(props) {
        super(props);
        this.state = {
            center: {
                lat: 0,
                lng: 0
            },
            loading: false,
            zoom: 12,
            currentLocation: {
                lat: 1.27958770,
                lng: 103.83588810
            },
            filterType: "",
            eBinTypeFilters: [],
            searchAddress: "",
            markers: [],

        }
    }

    componentDidMount = async () => {

        this.getTrash();
    }

    getUserCurrentLocation = async () => {
        if (navigator.geolocation) {
            await navigator.geolocation.getCurrentPosition(this.getCurrentLatLng, this.errorFunction);
        }
        else {
            alert('It seems like Geolocation, which is required for this page, is not enabled in your browser.');
        }
    }

    getCurrentLatLng = async (position) => {
        this.setState({
            currentLocation: {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            }
        }, () => { this.getTrash() });
    }

    errorFunction = (position) => {
        alert('Please allow location to get proper data!');
    }

    // getCurrentLocation = async (position) => {
    //     this.setState({
    //         currentLocation: {
    //             lat: position.coords.latitude,
    //             lng: position.coords.longitude
    //         }
    //     }, () => { this.getTrash() });
    // }

    getTrash = async () => {
        this.setState({ loading: true })
        let data = {
            latitude: this.state.currentLocation.lat,
            longitude: this.state.currentLocation.lng,
            filter: this.state.filterType ? this.state.filterType : "E_BIN"
        }

        if (this.state.filterType === "E_BIN")
            data.eBinsTypes = this.props.filter.eBinTypes

        await new Api().post('trash-ure/web-map', {
            data
        }).then(response => {
            if (response && response.data) {
                this.setState({
                    markers: response.data.data.map(item => ({ ...item, latitude: item?.latitude.toFixed(8), longitude: item?.longitude.toFixed(8) })),
                    loading: false,
                });
            }
        });

    }

    // componentDidUpdate = () => {

    //     if (this.props.filter.eBinTypes && this.props.filter.eBinTypes.length) {

    //         if (differenceBy(this.props.filter.eBinTypes, this.state.eBinTypeFilters) === []) {
    //             this.setState({
    //                 filterType: this.props.filter.filterType,
    //                 eBinTypeFilters: this.props.filter.eBinTypes ? [...this.props.filter.eBinTypes] : []
    //             }, () => { this.getTrash() });
    //         }
    //     }
    // }

    componentDidUpdate = () => {

        if (this.props.filter.eBinTypes) {

            if (differenceBy(this.props.filter.eBinTypes, this.state.eBinTypeFilters)?.length) {
                this.setState({
                    filterType: this.props.filter.filterType,
                    eBinTypeFilters: this.props.filter.eBinTypes ? [...this.props.filter.eBinTypes] : []
                }, () => { this.getTrash() });
            }

            if (differenceBy(this.state.eBinTypeFilters, this.props.filter.eBinTypes)?.length) {
                this.setState({
                    filterType: this.props.filter.filterType,
                    eBinTypeFilters: this.props.filter.eBinTypes ? [...this.props.filter.eBinTypes] : []
                }, () => { this.getTrash() });
            }
        }
    }




    handleEventLocationChange = (mapAddress) => {
        this.setState({
            searchAddress: mapAddress,
            //zoom: 8
        })
        // if (mapAddress === "") {
        //     this.getUserCurrentLocation();
        // }
    };

    handleEventLocationSelect = (mapAddress) => {
        geocodeByAddress(mapAddress)
            .then((results) => {
                return results
            }
            )
            .then(async result => {
                let latLng = await getLatLng(result[0])

                let zoomLevel = 0;

                if (result[0].types[0]
                    .includes(
                        "locality"
                        || "sublocality"
                        || "sublocality_level_1"
                        || "sublocality_level_2"
                        || "sublocality_level_3"
                        || "sublocality_level_4"
                        || "sublocality_level_5"
                    )) {
                    zoomLevel = 12
                }
                else if (result[0].types[0]
                    .includes(
                        "administrative_area_level_1"
                        || "administrative_area_level_2"
                        || "administrative_area_level_3"
                        || "administrative_area_level_4"
                        || "administrative_area_level_5"
                        || "administrative_area_level_6"
                        || "administrative_area_level_7"
                    )) {
                    zoomLevel = 7
                }
                else if (result[0].types[0].includes("country")) {
                    if (result[0].formatted_address.includes("Singapore")) {
                        zoomLevel = 11
                    }
                    else {

                        zoomLevel = 5
                    }
                }
                else if (result[0].types[0]
                    .includes(
                        "political",
                        "establishment",
                        "airport"
                    )) {
                    zoomLevel = 16
                }
                else {
                    zoomLevel = 19
                }


                this.setState({
                    currentLocation: {
                        lat: latLng.lat,
                        lng: latLng.lng
                    },
                    searchAddress: mapAddress,
                    zoom: zoomLevel,
                }, () => {
                    this.getTrash();
                })
            })
            .catch(error => console.error('Error', error));
    };


    getLatLng = (latLng) => {
        let updatedLatLng;
        let exists = this.differMarkers.find((coordinate) => {
            return parseFloat(coordinate.latitude).toFixed(4) === latLng.latitude.toFixed(4) && parseFloat(coordinate.longitude).toFixed(4) === latLng.longitude.toFixed(4)
        })
        if (exists) {
            let latitude = 0.0
            let longitude = 0.0
            let COORDINATE_OFFSET = 0.00005
            if (this.offsetType === 0) {
                latitude = latLng.latitude + COORDINATE_OFFSET
                longitude = latLng.longitude
            }
            if (this.offsetType === 1) {
                latitude = latLng.latitude - COORDINATE_OFFSET
                longitude = latLng.longitude
            }
            if (this.offsetType === 2) {
                latitude = latLng.latitude
                longitude = latLng.longitude + COORDINATE_OFFSET
            }
            if (this.offsetType === 3) {
                latitude = latLng.latitude
                longitude = latLng.longitude - COORDINATE_OFFSET
            }
            if (this.offsetType === 4) {
                latitude = latLng.latitude + COORDINATE_OFFSET
                longitude = latLng.longitude + COORDINATE_OFFSET
            }
            this.offsetType++
            if (this.offsetType === 5) {
                this.offsetType = 0
            }
            updatedLatLng = this.getLatLng({latitude, longitude})
        } else {
            this.differMarkers.push(latLng)
            updatedLatLng = latLng
        }
        return updatedLatLng
    }



    render() {
        let { markers, loading } = this.state;
        const center = { lat: 1.27958770, lng: 103.83588810 };
        if (markers && markers.length && markers.length > 0) {
            center.lat = markers[0].latitude;
            center.lng = markers[0].longitude;
        }

        // markers = markers.map((item) => {
        //     let newCoordinates = this.getLatLng({ latitude: parseFloat(item.latitude), longitude: parseFloat(item.longitude) })
        //     item.latitude = newCoordinates.latitude
        //     item.longitude = newCoordinates.longitude
        //     return item
        // })

        return (

            <DashboardWrapper className="flex f-v-center f-h-center f-column">
                <div className="home-map-container" style={{ position: "relative" }}>
                    {/* <GoogleMapReact
                        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_API_KEY }}
                        center={center}
                        zoom={this.state.zoom}
                        language='en'
                        yesIWantToUseGoogleMapApiInternals
                    // onGoogleApiLoaded={({ map, maps }) => this.handleApiLoaded(map, maps)}
                    >
                        {loading ? <CircularProgress /> :
                            markers.map((marker, index) => (
                                <MapMarkerDetail data={marker} showDetails={true} lat={marker.latitude} lng={marker.longitude} key={index} />
                            ))
                        }

                    </GoogleMapReact> */}

                    <GMap data={markers} center={this.state.currentLocation} loading={loading} zoomLevel={this.state.zoom} />
                    {
                        <PlacesAutocomplete
                            value={this.state.searchAddress}
                            onChange={this.handleEventLocationChange}
                            onSelect={this.handleEventLocationSelect}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div style={{
                                    position: "absolute",
                                    top: "10px",
                                    left: "10px",
                                }}>
                                    <input
                                        {...getInputProps({
                                            placeholder: 'Search Address...',
                                            className: 'location-search-input',
                                        })}
                                        placeholder="Search Location"
                                        style={{
                                            boxSizing: `border-box`,
                                            border: `1px solid transparent`,
                                            width: `240px`,
                                            height: `32px`,
                                            padding: `0 12px`,
                                            borderRadius: `3px`,
                                            boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                            fontSize: `18px`,
                                            outline: `none`,
                                            textOverflow: `ellipses`,
                                        }}
                                    />
                                    <div className="autocomplete-dropdown-container">
                                        {loading && <div>Loading...</div>}
                                        {suggestions.map(suggestion => {
                                            const className = suggestion.active
                                                ? 'suggestion-item--active'
                                                : 'suggestion-item';
                                            // inline style for demonstration purpose
                                            const style = suggestion.active
                                                ? { backgroundColor: '#fafafa', cursor: 'pointer', fontSize: "14px" }
                                                : { backgroundColor: '#ffffff', cursor: 'pointer', fontSize: "14px" };
                                            return (
                                                <div
                                                    {...getSuggestionItemProps(suggestion, {
                                                        className,
                                                        style,
                                                    })}
                                                >
                                                    <span>{suggestion.description}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete>
                    }
                </div>

            </DashboardWrapper>

        )
    }
}


const mapReduxStateToProps = (state) => ({
    filter: state.Filter.filter
})

export default connect(mapReduxStateToProps, { showToast })(Dashboard);